<template lang="html">
	<div v-show="realLaunch" class="modal-container row" :class="{activated: launch}" @mousedown="close">
		<div class="modal-content" :class="modalContentClass" @mousedown.stop>
			<component v-if="show" :data="data" :is="content" @close="close"/>
		</div>
	</div>
</template>

<script>
export default {
	name: 'baseModal',
	props: ['show', 'content', 'data', 'modalContentClass'],
	data () {
		return {
			launch: false,
			realLaunch: false
		}
	},
	mounted () {
		if (this.show) {
			this.launch = true
			this.realLaunch = true
		}
	},
	methods: {
		close () {
			this.$emit('close')
		}
	},
	watch: {
		show (value) {
			if (value) {
				this.realLaunch = true
				window.setTimeout(() => { this.launch = true }, 10)
			} else {
				window.setTimeout(() => { this.launch = false }, 10)
				window.setTimeout(() => { this.realLaunch = false }, 510)
			}
		}
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/common/components/baseModal.vue